import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootStyle: {
      marginLeft: 7,
      maxWidth: '50%',
      display: 'flex',
      flexDirection: 'column',
    },
    entityTitleStyle: {
      color: theme.palette.grey[700],
      fontSize: 18,
      fontWeight: 'bold',
    },
    skeleton: {
      transform: 'none',
    },
  }),
);
